<script>
    import { link } from "svelte-routing";
    import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
    import AuthError from "../auth/AuthError.svelte";
    import NewPassword from "../passwords/NewPassword.svelte";
    import PasswordRequirements from "../passwords/PasswordRequirements.svelte";
    import Input from "../Input.svelte";

    export let auth;
    export let actionCode;
    // export let continueUrl;
    // export let lang;

    let isActionCodeValid = undefined;
    let resetComplete = false;
    let errorCode;

    let input = {
        email: "",
        password: ""
    };

    // Verify the password reset code is valid.
    verifyPasswordResetCode(auth, actionCode)
    .then((email) => {
        input.email = email;
        isActionCodeValid = true;
    }).catch((error) => {
        isActionCodeValid = false;
    });

    function resetPassword() {
        // Save the new password.
        confirmPasswordReset(auth, actionCode, input.password).then((res) => {
            resetComplete = true;
            // TODO: Display a link back to the app, or sign-in the user directly
            // if the page belongs to the same domain as the app:
            // auth.signInWithEmailAndPassword(accountEmail, newPassword);

            // TODO: If a continue URL is available, display a button which on
            // click redirects the user back to the app via continueUrl with
            // additional state determined from that URL's parameters.
        })
        .catch((error) => {
            errorCode = error.code;
        });
    }
</script>

<div class="form">
    {#if isActionCodeValid == true}
        {#if !resetComplete}
            <h1>Passwort zurücksetzen</h1>
            <form on:submit|preventDefault={resetPassword}>
                <p>für {input.email}</p>
                <Input type="password" bind:value={input.password} label="Neues Passwort" autocomplete="new-password"/>
                <PasswordRequirements bind:password={input.password}/>
                <div class="actions">
                    <button type="submit">Speichern</button>
                </div>
            </form>
            <AuthError errorCode={errorCode}/>
        {:else}
            <h1>Passwort geändert</h1>
            <p>Du kannst dich jetzt mit deinem neuen Passwort anmelden.</p>
            <a href="/" use:link>Zum Login</a>
        {/if}
    {:else if isActionCodeValid == false}
        <h1>Fehler aufgetreten</h1>
        <p>Der Link zum Passwort zurücksetzen ist ungültig oder abgelaufen. Bitte versuche es erneut dein Passwort zurückzusetzen.</p>
    {/if}
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }

    .actions {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
    }
</style>
